import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import Contact from "./Contact";

export default function ContactPage() {
  return (
    <>
      <NavBar border="true" />
      <Contact />
      <Footer />
    </>
  );
}
